var indexAlpha = {
	guideIndex: {},
	orderedIndex: [],
	data: {}
}

indexAlpha.init = function (urlToIndex) {
	$.ajax({
		type: "GET",
		url: urlToIndex,
		dataType: "text",
		async: true,
		error: function (jqXHR, textStatus, errorThrown) {
			console.log("error loading index alpha : " + textStatus);
		}
	}).done(function (data) {
		indexAlpha.createIndexAlphaFromXml(data);
	});
}

indexAlpha.initData = function (urlToIndex) {
	$.ajax({
		type: "GET",
		url: urlToIndex,
		dataType: "json",
		async: true,
		error: function (jqXHR, textStatus, errorThrown) {
			console.log("error loading index alpha : " + textStatus);
		}
	}).done(function (data) {
		indexAlpha.data = data;

		for ( var key in indexAlpha.data ) {
			var indexAlphaData = indexAlpha.data[key]

			if ( indexAlphaData.uuid.charAt(0) === '#' ) {
				indexAlphaData.uuid = "other" + indexAlphaData.uuid.substring(1)
				break;
			}
		}
	});
}

indexAlpha.createIndexAlphaFromXml = function (dataXml) {
	var source = indexAlpha.createJsonFromXML(dataXml);
	source.index = indexAlpha.sortIndex(source.index);

	indexAlpha.generateIndexAlpha(source);
}

indexAlpha.createJsonFromXML = function (dataXml) {
	var x2js = new X2JS();
	var jsonData = x2js.xml_str2json(dataXml);

	return jsonData.guideIndex;
}

indexAlpha.sortIndex = function (index) {
	if (!index) { return {} }
	if (!index.length) { return index }

	return index.sort(function (word1, word2) {
		var foldedWord1 = accentHighlight.replaceAccent(word1.label);
		var foldedWord2 = accentHighlight.replaceAccent(word2.label);

		if (foldedWord1 < foldedWord2)
			return -1;
		if (foldedWord1 > foldedWord2)
			return 1;

		return 0;
	});
}

indexAlpha.generateIndexAlpha = function (source) {	
	var alphabet = "abcdefghijklmnopqrstuvwxyz";
	var isInIndex = [];
	var indexAlphaTest = "a";

	for (var i = 0; i < alphabet.length; i++) {
		var letterIndex = {
			letter: alphabet.substring(i, i + 1),
			words: []
		}

		for (var j = 0; j < source.index.length; j++) {
			var sourceWithNoAccent = "";

			if (source.index[j] != null) {
				var targetAlpha = source.index[j].label.toLowerCase().substring(0, 1);
				sourceWithNoAccent = accentHighlight.replaceAccent(source.index[j].label.toLowerCase());
			}
			if (sourceWithNoAccent.startsWith(alphabet.substring(i, i + 1))) {
				letterIndex.words.push(source.index[j]);
				isInIndex.push(j);
			}
		}
		if (letterIndex.words.length > 0) {
			indexAlpha.orderedIndex.push(letterIndex);
		}
	}

	// Gestion des autres cas : Entrée #
	var letterIndex = {
		letter: '#',
		words: []
	}
	for (var j = 0; j < source.index.length; j++) {
		var flag = false;

		for (var k = 0; k < isInIndex.length; k++) {
			if (j == isInIndex[k]) {
				flag = true;
			}
		}

		if (flag == false) {
			source.index[j].label != "" ? letterIndex.words.push(source.index[j]) : '';
			isInIndex.push(j);
		}
	}
	if (letterIndex.words.length > 0) {
		indexAlpha.orderedIndex.push(letterIndex);
	}

}

indexAlpha.addMenuItem = function () {
	var itemSource = {
		href: "internal/indexalpha",
		key: "INDEX",
		title: i18n.t("title_index_alpha", { lng: ddbViewerParams.data.lang_language })
	}

	navigationWeb.listSummary.push(itemSource.href);
	navigationWeb.mapSummaryKeyUrl[itemSource.key] = itemSource.href;
	navigationWeb.mapSummaryUrlKey[itemSource.href] = itemSource.key;

	return itemSource;
}

indexAlpha.generateTemplateData = function () {
	var templateData = [];

	for (letterKey in indexAlpha.orderedIndex) {
		var letter = indexAlpha.orderedIndex[letterKey];
		if (letter.words.length && letter.words.length > 0) {
			for (keyWord in letter.words) {
				var word = letter.words[keyWord]
				if (word.functions && word.functions.function && !word.functions.function.length) {
					word.label = '<a href="#' + word.functions.function.id + '">' + word.label + '</a>';

					word.functions = null;
				}
			}
		}

		templateData.push(letter);
	}

	return templateData;
}

indexAlpha.loadPage = function(target) {
	var id = navigationWeb.mapSummaryHrefId[target + ".dita"]
	var key = navigationWeb.mapSummaryUrlKey[id]

	navigationWeb.activateItemSummaryFromId(key)
	pap.loadPage(id)
}

indexAlpha.goToAnchor = function (id) {
	if (id != null && id !== undefined) {
		var $element = $("#" + id);
		var $contentScrollable = $(".indexAlphaContent");
		/*var scrollValue = $element.offset().top - $element.height() - 50;*/
		var currentScrollPosition = $contentScrollable.scrollTop();
		var scrollValue = currentScrollPosition + ($element.offset().top - 62);
		$contentScrollable.scrollTop(scrollValue);
	}
}

indexAlpha.loadHref = function($newContent) {
	const $dataIndexAlphaTargets = $newContent.find("[data-index-alpha-target]");

	for (const dataIndexAlphaTargetItem of $dataIndexAlphaTargets) {
		const target = dataIndexAlphaTargetItem.getAttribute("data-index-alpha-target");
		const id = navigationWeb.mapSummaryHrefId[target + ".dita"];

		dataIndexAlphaTargetItem.setAttribute("href", "#" + id)
	}
}